import type { Dimension, IdeaDetail } from '@/api/types';
import { PageHead } from '@/ui/PageHead';
import { LoadingCard } from '@/ui/StateCard';

import { formatDate } from '../ideaUi';
import { IdeaReportCard } from './IdeaDocument';
import { IdeaDialogs } from './IdeaDialogs';
import { IdeaFacts } from './IdeaFacts';
import { IdeaStrip } from './IdeaStrip';
import { ResearchNotices } from './ResearchNotices';
import { shownResearch, type IdeaDetailUi } from './useIdeaDetail';

/** The loaded idea: head, facts and actions, research notices, the summary strip, the report, and the dialogs. */
interface Props {
  idea: IdeaDetail;
  dimensions: Dimension[];
  ui: IdeaDetailUi;
  back: { to: string; name: string };
}

export function IdeaDetailBody({ idea, dimensions, ui, back }: Props) {
  const shown = shownResearch(idea, ui);
  return (
    <>
      <PageHead
        title={idea.title}
        back={back}
        subtitle={`Submitted by ${idea.author.display_name} on ${formatDate(idea.created_at)}`}
      />
      <IdeaFacts idea={idea} ui={ui} />
      <ResearchNotices idea={idea} ui={ui} />
      {shown && <IdeaStrip research={shown} dimensions={dimensions} benchmark={idea.industry_benchmark ?? null} />}
      {ui.viewing && ui.pastRun.isPending && <LoadingCard label="Loading the earlier run" />}
      {shown && <IdeaReportCard research={shown} />}
      <IdeaDialogs idea={idea} ui={ui} />
    </>
  );
}
